import React from 'react';
import Layout from '../components/Layout';
import LoginForm from '../components/LoginCard';

function Login() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/20004535-uhd_2560_1440_30fps_wvukgh.mp4">
      <LoginForm />
    </Layout>
  );
}

export default Login;